import { createApp } from 'vue';
import App from './App.vue';
import { createPinia } from 'pinia';
import router from './router';
import { api, api2 } from './stores/taskStore';
import BaseSelect from './components/common/BaseSelect.vue';
import BaseDatePicker from './components/common/BaseDatePicker.vue';
import dialog from './directives/dialog';

const app = createApp(App);

// The one dropdown every screen uses in place of a native <select>.
app.component('BaseSelect', BaseSelect);
// ...and the one date picker, in place of <input type="date">.
app.component('BaseDatePicker', BaseDatePicker);

// Esc, focus trap and dialog semantics for every modal panel.
app.directive('dialog', dialog);

app.config.globalProperties.$api = api;
app.config.globalProperties.$api2 = api2;

app.use(createPinia());
app.use(router);
app.mount('#app');

import './assets/css/main.css';
